var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zwx-scrollbar-y"},[_c('el-scrollbar',{ref:"scrollbarY",staticClass:"zwx-scrollbar-box-y"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }